const AUTH_CLIENT_ID = process.env.REACT_APP_AUTH_CLIENT_ID ?? "";
const AUTH_SCOPE = process.env.REACT_APP_AUTH_SCOPE ?? "";
const AUTHORITY = process.env.REACT_APP_AUTH_AUTHORITY ?? "";
const AUTH_REDIRECT_URI = process.env.REACT_APP_AUTH_REDIRECT_URI ?? "http://localhost:3000/login";
const AUTH_LOGOUT_REDIRECT_URI = process.env.REACT_APP_AUTH_LOGOUT_REDIRECT_URI ?? "/";
export const msalConfig = {
    auth: {
        clientId: AUTH_CLIENT_ID,
        authority: AUTHORITY,
        redirectUri: AUTH_REDIRECT_URI,
        postLogoutRedirectUri: AUTH_LOGOUT_REDIRECT_URI,
    },
    system: {
        allowPlatformBroker: true,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true,
    },
};
export const loginRequest = {
    scopes: [AUTH_SCOPE ?? ''],
};
